import { createPlayground } from "./create-playground.js";
var app_default = createPlayground();
export {
  app_default as default
};
//# sourceMappingURL=app.js.map
